import { Accounts } from "../../accounts/accounts";
import { h } from "../../../_common/jsx-dom.svg.js";

const TAG = "mobile-rg-header-accounts";

export class MobileAccounts extends HTMLElement {

    _ele;
    _userData;

    constructor(userData) {
        super();
        this._userData = userData;
    }

    connectedCallback() {

        const accountChangeOptions = new Accounts(this._userData).transform();

        this._ele = (
            <span>
                {accountChangeOptions && accountChangeOptions.showAccountChangeList && ([
                    <a class="page-nav-top__link page-nav-top__icon--register" id="MaxCustomerAccount">{accountChangeOptions.activeAccount.customerName} ({accountChangeOptions.activeAccount.customerNumber})</a>,
                    <div class="page-nav-top__link-sub-group" id="CustomerAccountList">
                        <span class="page-nav-top__sub-nav-heading">Switch to my account</span>
                        {accountChangeOptions.accountChangeListOptions.map((accountChangeListOption) => {
                            return (
                                <a class={"page-nav-top__link-sub account-list-item " + accountChangeListOption.accountTypeStyleClass + " " + accountChangeListOption.activeStyleClass} href="/max" data-customer-number={accountChangeListOption.customerNumber}>
                                    {accountChangeListOption.customerName}
                                    <span>{accountChangeListOption.isParentAccount ? `Parent` : accountChangeListOption.isChildAccount ? `Child` : ""} Account No: {accountChangeListOption.customerNumber}</span>
                                </a>
                            )
                        })}
                        {accountChangeOptions.showAccountChangeLink && (
                            <a class="page-nav-top__link-sub page-nav-top__link-sub--all" href="/max/user-profile/trade-accounts" id="ListMoreAccounts">
                                See my other accounts
                            </a>
                        )}
                    </div>
                ])}
                {accountChangeOptions && !accountChangeOptions.showAccountChangeList && (
                    <a href="#" class="header-top-right-nav__link header-top-right-nav__icon--register" id="MaxCustomerAccount">{accountChangeOptions.activeAccount.customerName} ({accountChangeOptions.activeAccount.customerNumber})</a>
                )}
            </span>
        );

        this.appendChild(this._ele);
    }
}

customElements.define(TAG, MobileAccounts);
